import {formatAmountInput} from './currencyInput';
import {getMoralIncreasePercentage} from './permanentDamage';

export function calculationPdfRows({box,result,age,parameters}){
 const money=v=>'€ '+formatAmountInput(v),num=v=>Number(v||0).toLocaleString('it-IT');
 const moral={min:'Minimo',med:'Medio',max:'Massimo'};
 const permanentIncrease=box.moraleBiologico?getMoralIncreasePercentage(box.dannoBiologico,age,box.moraleBiologico,parameters.coefficienti_eta):0;
 return [
  {section:'Danno permanente'},
  ...(result.differential ? [{label:'Biologico complessivo dopo evento',input:num(result.differential.final)+'%',amount:money(result.differential.after)},{label:'Biologico preesistente',input:num(result.differential.preexisting)+'%',amount:'- '+money(result.differential.before)},{label:'Danno biologico differenziale',amount:money(result.dannoBiologico),total:true}] : [{label:'Danno biologico',input:num(box.dannoBiologico)+'%',amount:money(result.dannoBiologico)}]),
  {label:result.differential?'Morale sul biologico differenziale':'Danno morale su biologico',input:box.moraleBiologico?(moral[box.moraleBiologico]+' +'+num(permanentIncrease)+'%'):'Nessuno',amount:money(result.dannoMoraleBiologico)},
  {label:'Totale permanente',amount:money(result.dannoBiologico+result.dannoMoraleBiologico),total:true},
  {section:'Danno temporaneo'},
  ...[[100,'giorni100'],[75,'giorni75'],[50,'giorni50'],[25,'giorni25']].map(([percent,key])=>({label:'Giorni al '+percent+'%',input:num(box[key]),amount:money(Number(box[key]||0)*Number(parameters.valore_giorno_micro)*percent/100)})),
  {label:'Totale danno temporaneo',amount:money(result.dannoTemporaneo),total:true},
  {label:'Danno morale su temporaneo',input:num(box.moraleTemporaneo)+'%',amount:money(result.dannoMoraleTemporaneo)},
  {section:'Spese e totale'},
  {label:'Spese mediche',amount:money(result.speseMediche)},
  {label:'Spese accessorie',amount:money(result.speseAccessorie)},
  {label:'Mancato guadagno',amount:money(result.mancatoGuadagno)},
  {label:'Danno materiale',amount:money(result.dannoMateriale)},
  {label:'Totale complessivo',amount:money(result.totale),total:true},
  {label:'Responsabilità controparte',input:num(result.responsabilitaControparte)+'%'},
  {label:'Totale spettante',amount:money(result.totaleSpettante),total:true,final:true}
 ];
}
// Public CIS report: omit unused entries, keeping the full internal sheet unchanged.
export function cisCalculationRows(input){
 const {box,result}=input;
 const permanent=Number(box.dannoBiologico)>0||!!result.differential;
 const temporary=result.dannoTemporaneo>0;
 const rows=calculationPdfRows(input).filter(row=>{
  if(row.section==='Danno permanente')return permanent;
  if(['Danno biologico','Totale permanente'].includes(row.label))return permanent;
  if(row.label==='Danno morale su biologico'||row.label==='Morale sul biologico differenziale')return permanent&&!!box.moraleBiologico;
  if(row.section==='Danno temporaneo'||row.label==='Totale danno temporaneo')return temporary;
  if(row.label?.startsWith('Giorni al '))return Number(String(row.input).replace(',','.'))>0;
  if(row.label==='Danno morale su temporaneo')return temporary&&Number(box.moraleTemporaneo)>0;
  if(['Spese accessorie','Mancato guadagno','Danno materiale'].includes(row.label))return false;
  if(row.label==='Spese mediche')return result.speseMediche>0;
  if(row.label==='Totale complessivo'||row.label==='Responsabilità controparte')return result.responsabilitaControparte!==100;
  return true;
 });
 if(result.personalizzazione>0){
  const at=rows.findIndex(row=>row.label==='Totale permanente');
  const personal={label:'Personalizzazione',input:Number(result.percentualePersonalizzazione).toLocaleString('it-IT')+'%',amount:'€ '+formatAmountInput(result.personalizzazione)};
  if(at>=0){rows.splice(at,0,personal);rows[at+1]={...rows[at+1],amount:'€ '+formatAmountInput(result.dannoBiologico+result.dannoMoraleBiologico+result.personalizzazione)};}
 }
 return rows;
}
